export const useTabNavigation = () => ({
    navigateToTab: (tabTestId: string) => {
        const tab = document.querySelector<HTMLButtonElement>(`[data-testid="${tabTestId}"]`);
        if (tab && tab.getAttribute('aria-selected') !== 'true') tab.click();
    },
});
